import { navigate } from 'gatsby'
import useRoute from './useRoute'

const useNavigation = () => {
  const routable = useRoute()

  return to => {
    if (routable) navigate(to)
  }
}

export default useNavigation
